import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@mui/material';
import { IProduto } from '../interfaces';

interface ProductDetailProps {
    open: boolean;
    onClose: () => void;
    product: IProduto | null;
}

const ProductDetail: React.FC<ProductDetailProps> = ({ open, onClose, product }) => {
    if (!product) return null;

    const tiers = product.tiers || []; // Ensure tiers is defined

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Detalhes do Produto</DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Nome:</Typography>
                    <Typography>{product.name}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Descrição:</Typography>
                    <Typography>{product.description}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Preço:</Typography>
                    <Typography>
                        {product.preco !== undefined && product.preco !== null
                            ? `R$ ${product.preco.toFixed(2)}`
                            : 'N/A'}
                    </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">URL de Integração:</Typography>
                    <Typography>{product.integrationUrl ? product.integrationUrl : 'N/A'}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Ativo:</Typography>
                    <Typography>{product.ativo ? 'Sim' : 'Não'}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Data de Criação:</Typography>
                    <Typography>{product.createdAt ? new Date(product.createdAt).toLocaleDateString() : 'N/A'}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Última Atualização:</Typography>
                    <Typography>{product.updatedAt ? new Date(product.updatedAt).toLocaleDateString() : 'N/A'}</Typography>
                </Box>
                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Módulos
                    </Typography>
                    {product.modulos && product.modulos.length > 0 ? (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nome</TableCell>
                                    <TableCell>Descrição</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {product.modulos.map((modulo, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{modulo.name}</TableCell>
                                        <TableCell>{modulo.description}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <Typography>Nenhum módulo cadastrado.</Typography>
                    )}
                </Box>
                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Faixas de Preço
                    </Typography>
                    {tiers && tiers.length > 0 ? (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Início da Faixa</TableCell>
                                    <TableCell>Fim da Faixa</TableCell>
                                    <TableCell>Preço</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tiers.map((tier, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{tier.rangeStart}</TableCell>
                                        <TableCell>{tier.rangeEnd}</TableCell>
                                        <TableCell>{`R$ ${tier.price.toFixed(2)}`}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <Typography>Nenhuma faixa cadastrada.</Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProductDetail;